
import {TrackerConfig} from './types';

const CACHE_KEY = 'obs-config';
const TTL_MS = 60000;

export const DEFAULT_CONFIG: TrackerConfig = {
	replay_sample_rate: 0,
	excluded_paths: [],
	experiments: [],
};

// Project config from /o/config, cached per tab so page loads don't refetch.
// Falls back to "no replay" when the endpoint is unreachable.
export const loadConfig = async (endpoint: string, key: string): Promise<TrackerConfig> => {
	try {
		const cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null') as
			{at: number, config: TrackerConfig} | null;
		if (cached && Date.now() - cached.at < TTL_MS) {
			return cached.config;
		}
	} catch {
		// storage blocked or corrupt; fetch fresh
	}
	try {
		const r = await fetch(`${endpoint}/config?k=${encodeURIComponent(key)}`);
		if (!r.ok) {
			return DEFAULT_CONFIG;
		}
		const config = {...DEFAULT_CONFIG, ...(await r.json() as Partial<TrackerConfig>)};
		try {
			sessionStorage.setItem(CACHE_KEY, JSON.stringify({at: Date.now(), config}));
		} catch {
			// ignore
		}
		return config;
	} catch {
		return DEFAULT_CONFIG;
	}
};
